<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div>
        <b-alert show variant="primary" class="text -center">{{ textoPasoRecibe }}</b-alert>
      </div>
    <div class="tab_container" style="margin-left: 8rem">
    <div v-for="tabs in listaTabsRecibe"
      v-bind:key="tabs.idTabs">
      <input
        :id="tabs.nombreTabs"
        type="radio"
        name="tabs"
        :checked="tabs.checkTabs"
        :disabled="tabs.disabledTabs"
      />
      <label :for="tabs.nombreTabs"><span>
             <em :class="tabs.icono"></em></span></label>
    </div>
    </div>
  </div>
</template>

<script>
export default {
props: {
    listaTabsRecibe: null,
    textoPasoRecibe: null
  },
  name: "wizarMenuProcesos",
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
};
</script>

<style>
.tab_container > div > label > span {
  font-size: 28px;
  color: white;
  background-color: #0e6ba9;
  width: 44px;
  border-radius: 50%;
}

.container {
  margin-top: 10px;
}
.capsula {
  margin: 0 auto;
  width: 85%;
  background: rgb(255, 255, 255);
  border-radius: 10px;
  padding: 20px 30px 0;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px,
    rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px;
}

.input,
.btn {
  border-radius: 20px;
}

.input {
  width: 95%;
}
.tab_container {
  width: 100%;
  margin: 0 auto;
  padding-top: 10px;
}
.tab_container > div > input {
  clear: both;
  display: none;
}
.tab_container > div > section {
  clear: both;
  padding-top: 40px;
  display: none;
}

.tab_container > div > label {
  font-weight: 700;
  font-size: 18px;
  display: flex;
  justify-content: center;
  float: left;
  width: 25%;
  padding: 1em;
  color: #757575;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
  background: #f0f0f0ef;
  border-radius: 90px;
}

#tab1:checked ~ #content1,
#tab2:checked ~ #content2,
#tab3:checked ~ #content3,
#tab4:checked ~ #content4 {
  display: block;
  background: #fff;
  color: #999;
}

.tab_container .tab-content p,
.tab_container .tab-content h3 {
  -webkit-animation: fadeInScale 0.7s ease-in-out;
  -moz-animation: fadeInScale 0.7s ease-in-out;
  animation: fadeInScale 0.7s ease-in-out;
}
.tab_container .tab-content h3 {
  text-align: center;
  font-size: 18px;
  padding-bottom: 15px;
  border-bottom: 2px solid #f0f0f0;
  text-transform: uppercase;
}

.tab_container [id^="tab"]:checked + label {
  background: #fff;
  box-shadow: inset 0 5px #0e6ba9;
}
/*Media query*/
@media only screen and (max-width: 900px) {
  .tab_container {
    width: 98%;
    margin-left: 3rem !important;
  }
}

@media only screen and (max-width: 900px) {
  .input {
    width: 143px;
  }
}
.alert-primary {
    color: #ffffff !important; 
    background-color: #0e6ba9 !important;
}
</style>